import ActionTypes from '../constants/ActionTypes';

const initialState = {
    menuData: [],
    isFetching: false,
    adminData: null,
    error: null,
    authority_class: null,
    reloadFolderFlag: 0
};

const menuReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_MENU_REQUEST:
            return { ...state, isFetching: true, error: null };

        case ActionTypes.FETCH_MENU_SUCCESS:
            return { ...state, isFetching: false, menuData: action.payload };

        case ActionTypes.FETCH_MENU_FAILURE:
            return { ...state, isFetching: false, error: action.payload };
        case ActionTypes.FETCH_USER_REQUEST:
            return {
                ...state,
                isFetching: true,
                errorMessage: null,
            };
        case ActionTypes.FETCH_USER_SUCCESS: 
            // console.log('authority_class:', action.payload.authority_class);
            return { ...state, isFetching: false, authority_class: action.payload.authority_class, error: null };
        case ActionTypes.FETCH_USER_FAILURE:
            return { ...state, isFetching: false, error: action.payload };
        case ActionTypes.TRIGGER_DATA_FOLDER_RELOAD:
            return { ...state, reloadFolderFlag: state.reloadFolderFlag + 1 };
        default:
            return state;
    }
};

export default menuReducer;
